import React from 'react'

import { CONFIG_NAME, useConfig } from './_load/ConfigLoader'
import { useSaveConfig } from './_request/saveConfig'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditConfigForm = () => {
  const config = useConfig()
  const [onSubmit, { loading, error }] = useSaveConfig()

  // No row for `availability_status_source` yet (never configured for this project):
  // start from an empty array so both checkboxes render unchecked instead of breaking.
  const initialState = config ? { ...config, value: config.value || [] } : { name: CONFIG_NAME, value: [] }

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialState}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditConfigForm
